module.exports = __webpack_public_path__ + "static/media/30@2x.f0323381.png";